/**
 * GraphQL Query
 * EC在庫画面
 */

/**
 * EC在庫一覧
 */
export const GRAPH_QL_QUERY_EC_STOCK_LIST =
`
query {
  ecStockListItems ( ? ) {
    edges {
      node {
        stockType
        site {
          code
          name
          type
        }
        sku {
          uuid
          product {
            code
            uuid
            name
          }
          color {
            code
            name
          }
          size {
            code
            name
          }
          code
          name
          artistName
          productType
        }
        ecStockDistr {
          amount
        }
        ecStock {
          standard
          registered
          allocated
          ordered
          exported
          qty
        }
      }
    }
    totalCount
  }
}
`

/**
 * EC在庫アラート一覧
 */
export const GRAPH_QL_QUERY_STOCK_ALERT_LIST =
`
query {
  ecStockAlertItems ( ? ) {
    edges {
      node {
        ecStockAlert {
          id
          site {
            code
            name
          }
        }
        id
        uuid
        no
        productId
        stockType
        alertType
        alertValue
        isEnabled
        note
        createdAt
        updatedAt
      }
    }
    totalCount
  }
}
`

/**
 * EC在庫アラート詳細
 */
export const GRAPH_QL_QUERY_STOCK_ALERT_DETAIL =
`
query {
  ecStockAlertItems ( ? ) {
    edges {
      node {
        ecStockAlert {
          site {
            code
          }
        }
        alerteds {
          statusCode
        }
        uuid
        no
        productId
        stockType
        alertType
        alertValue
        isEnabled
        note
      }
    }
    totalCount
  }
}
`

/**
 * 在庫調整指示一覧
 */
export const GRAPH_QL_QUERY_STOCK_ADJUSTMENT_LIST =
`
query {
  stockAdjustmentList ( ? ) {
    edges {
      node {
        uuid
        stockAdjustmentNo
        sku {
          code
          name
        }
        category
        qty
        note
        reason
        sendAt
        createdAt
      }
    }
    totalCount
  }
}
`

/**
 * 在庫移動指示一覧
 */
export const GRAPH_QL_QUERY_STOCK_MOVE_LIST =
 `
 query {
  stockMoveList ( ? ) {
    edges {
      node {
        site {
          code
        }
        uuid
        stockMoveNo
        name
        postalCode
        stateCode
        city
        address1
        address2
        phone
        preferredShippingAt
        reason
        note
        sendAt
        createdAt
        stockMoveItem {
          sku {
            code
            name
          }
          stockQty
          qty
        }
      }
    }
    totalCount
  }
}
`
/**
 * 出荷先一覧
 */
export const GRAPH_QL_QUERY_DESTINATION_LIST =
 `
 query {
  destinations ( ? ) {
    edges {
      node {
        uuid
        code
        name
        postalCode
        stateCode
        city
        address1
        address2
        phone
        displayOrder
      }
    }
    totalCount
  }
}
`
